<div class="dialog">
  @if (group.people.length) {
    <h1>{{ group.people[0].name }}</h1>
  }
  @if (!group.people.length) {
    <h1>A Guest</h1>
  }
  <div class="description">
    <app-svg [src]="group.icon" [attr.color]="group.iconColor"></app-svg>
    <p>
      {{ word | capitalize }}<b> {{ group.assetIds.length }} Assets</b>
    </p>
  </div>
  <div class="assets-container">
    <div class="assets" appScrollElement>
      @for (item of items; track item.assetId; let i = $index) {
        <div>
          <app-link-list-item
            *inView="i < 10; keep: true"
            [description]="item.item.time | date: 'short'"
            [title]="item.title"
            [link]="
              item.asset ? ['/a', 'gallery', item.item.context.gallery.id, 'designer', item.asset?.id] : undefined
            "
            fragment="comments"
            [image]="
              item.asset
                ? (item.asset | canDisplayAsset)
                  ? (item.asset.version_data
                    | assetVersionUrl
                      : item.asset
                      : item.asset.version_data.status
                      : 50
                      : 50
                      : !!group.gallery.watermark)
                  : ''
                : 'EMPTY'
            "
            imageStyle="plain"
            [size]="'tiny'"
          >
            @if (item.asset) {
              <app-activity-badge [onlyDot]="true" [asset]="item.asset" [hideBolt]="true" [hideWhenEmpty]="true">
              </app-activity-badge>
            }
          </app-link-list-item>
        </div>
      }
    </div>
  </div>
</div>
